import type { ProjectSettings } from '$lib/model/types';

// Compute target dimensions appropriate for a freshly-uploaded image,
// matching the source's orientation against the configured paper size.
// Returns the dimensions in the project's `units`.
export function orientTargetForSource(
  bitmapWidth: number,
  bitmapHeight: number,
  settings: ProjectSettings,
): { width: number; height: number } {
  const srcLandscape = bitmapWidth >= bitmapHeight;
  const paperLandscape = settings.paper_width_in >= settings.paper_height_in;
  const longInches = Math.max(
    settings.paper_width_in,
    settings.paper_height_in,
  );
  const shortInches = Math.min(
    settings.paper_width_in,
    settings.paper_height_in,
  );
  const wIn = srcLandscape ? longInches : shortInches;
  const hIn = srcLandscape ? shortInches : longInches;
  void paperLandscape;
  return convertFromInches(wIn, hIn, settings.units);
}

function convertFromInches(
  wIn: number,
  hIn: number,
  units: ProjectSettings['units'],
): { width: number; height: number } {
  if (units === 'in') return { width: wIn, height: hIn };
  if (units === 'cm')
    return { width: round2(wIn * 2.54), height: round2(hIn * 2.54) };
  return { width: round2(wIn * 25.4), height: round2(hIn * 25.4) };
}

function round2(n: number): number {
  return Math.round(n * 100) / 100;
}
